// Phase 8 R2 — fetch ordered lines for a single canned job (for editor).

import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export interface CannedJobLine {
  id: string;
  canned_job_id: string;
  line_type: 'part' | 'labor';
  part_description: string | null;
  part_number: string | null;
  quantity: number | null;
  labor_description: string | null;
  labor_hours: number | null;
  /** CAT-1/CAT-4: optional canonical jobs_catalog.code a labor line is bound to. */
  catalog_job_code: string | null;
  display_order: number;
}

export function useCannedJobLines(cannedJobId: string | null | undefined) {
  return useQuery({
    queryKey: ['canned-job-lines', cannedJobId],
    enabled: !!cannedJobId,
    queryFn: async (): Promise<CannedJobLine[]> => {
      const { data, error } = await (supabase as any)
        .from('canned_job_lines')
        .select(
          'id, canned_job_id, line_type, part_description, part_number, quantity, labor_description, labor_hours, catalog_job_code, display_order',
        )
        .eq('canned_job_id', cannedJobId)
        .order('display_order', { ascending: true })
        .order('created_at', { ascending: true });
      if (error) throw error;
      return (data ?? []) as CannedJobLine[];
    },
  });
}
